const we = [
  "We are a digital agency. We deal with almost everything starting from influencer marketing, designing, social media, photography campaigns, photo and video editing, website development to complete digital marketing.",
  "You see something that has to be done for your brand on the internet? We can make it happen.",
  "From planning out your social media to curating content for it, we got an arsenal of services so you don’t have to go out looking for different things and bring them together.",
  "With as vision of simplicity, we started as an organisation that does what is necessary and leave out anything that won’t bring about a difference. This lets us keep our vision for each brand straight without clutter or confusion.",
  "The Graphic Social is the property of The Parent Company.",
];

export default we;
